import { render } from "./simpeg-pegawai-list-remote.vue?vue&type=template&id=61c1f280"
import script from "./simpeg-pegawai-list-remote.vue?vue&type=script&lang=js"
export * from "./simpeg-pegawai-list-remote.vue?vue&type=script&lang=js"

import "./simpeg-pegawai-list-remote.vue?vue&type=style&index=0&id=61c1f280&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__